/* Forum entry uses the bridge's existing credentialed JSON SSO contract. */
(function (factory) {
  var gateway = factory();
  if (typeof module === 'object' && module.exports) module.exports = gateway;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    var boot = function () {
      document.querySelectorAll('[data-pg-forum-gateway]').forEach(function (root) { gateway.mount(root, window); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }
})(function () {
  'use strict';
  var FORUM_ORIGIN = 'https://community.pixelgipfel.ch';
  var SHOP_ORIGIN = 'https://pixelgipfel.ch';
  var API_ORIGIN = 'https://api.pixelgipfel.ch';

  function forumPath(value) {
    if (typeof value !== 'string' || value.length > 2048 || value.charAt(0) !== '/') return '/';
    try {
      var decoded = decodeURIComponent(value);
      if (/[\s\\?#%\u0000-\u001f\u007f]/.test(decoded) || decoded.indexOf('//') !== -1) return '/';
      var indexRoute = /^\/(?:recent|unread|categories|popular)?\/?$/;
      var discussionRoute = /^\/(?:topic|category)\/[1-9]\d*(?:\/[\p{L}\p{N}_-]+)?(?:\/[1-9]\d*)?\/?$/u;
      var ownHistoryRoute = decoded === '/me/topics' || decoded === '/me/posts';
      if (!indexRoute.test(decoded) && !discussionRoute.test(decoded) && !ownHistoryRoute) return '/';
      var url = new URL(value, FORUM_ORIGIN);
      return url.origin === FORUM_ORIGIN ? url.pathname : '/';
    } catch (_error) { return '/'; }
  }

  function gatewayPath(value) {
    // Liquid owns this path; unexpected editor input must not create an external redirect.
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/zum-forum$/.test(value || '') ? value : '/pages/zum-forum';
  }

  function productPath(value) {
    // The query parser unwraps its value; this accepts one path-encoding layer, never another origin or encoded route separators.
    if (typeof value !== 'string' || value.length > 2048 || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2,4})?\/)?products\//.test(value)) return null;
    try {
      var decoded = decodeURIComponent(value);
      if (/[\s\\?#%\u0000-\u001f\u007f]/.test(decoded) || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2,4})?\/)?products\/[\p{L}\p{M}\p{N}_™®-]+\/?$/u.test(decoded)) return null;
      var canonical = new URL(decoded, SHOP_ORIGIN).pathname;
      return canonical.length <= 2048 ? canonical : null;
    } catch (_error) { return null; }
  }

  function gatewayUrl(path, destination, productReturn) {
    var back = new URL(gatewayPath(path), SHOP_ORIGIN);
    var safePath = forumPath(destination);
    if (safePath !== '/') back.searchParams.set('return', safePath);
    var safeProduct = productPath(productReturn);
    if (safeProduct) back.searchParams.set('product_return', safeProduct);
    return back.pathname + back.search;
  }

  function loginUrl(path, destination, locale, productReturn) {
    var login = new URL('/customer_authentication/login', SHOP_ORIGIN);
    login.searchParams.set('return_to', gatewayUrl(path, destination, productReturn));
    if (/^[a-z]{2}(?:-[a-zA-Z]{2,4})?$/.test(locale || '')) login.searchParams.set('locale', locale);
    return login.pathname + login.search;
  }

  function ssoUrl(value) {
    try {
      var url = new URL(value);
      if (url.origin !== API_ORIGIN || url.pathname !== '/customer/sso' || url.username || url.password) return null;
      if (!/^\d+$/.test(url.searchParams.get('customer_id') || '') || !/^[a-f0-9]{22}$/.test(url.searchParams.get('token') || '')) return null;
      url.searchParams.delete('return');
      return url;
    } catch (_error) { return null; }
  }

  function mount(root, win) {
    if (root.getAttribute('data-pg-forum-ready') === 'true') return;
    root.setAttribute('data-pg-forum-ready', 'true');
    var action = root.querySelector('[data-pg-forum-action]');
    var reading = root.querySelector('[data-pg-forum-read]');
    var status = root.querySelector('[data-pg-forum-status]');
    var spinner = root.querySelector('[data-pg-forum-spinner]');
    if (!action || !reading || !status) return;
    var authenticated = root.getAttribute('data-authenticated') === 'true';
    var source;
    try { source = new URL(win.location.href); } catch (_error) { return; }
    var destination = forumPath(source.searchParams.get('return'));
    var forum = FORUM_ORIGIN + destination;
    var productReturn = productPath(source.searchParams.get('product_return'));
    var completedDestination = productReturn ? SHOP_ORIGIN + productReturn + '#pg-product-community' : forum;
    var endpoint = authenticated ? ssoUrl(root.getAttribute('data-sso-url')) : null;
    var pending = false;
    var attempt = 0;
    var timeout = 0;
    var controller = null;
    var identityInvalid = false;
    var initialLogoutVersion = win.pgForumSession && win.pgForumSession.logoutVersion ? win.pgForumSession.logoutVersion() : '';

    // Own history requires the reset and signed bridge; guest reading stays public.
    reading.href = destination === '/me/topics' || destination === '/me/posts' ? FORUM_ORIGIN + '/' : forum;
    if (authenticated && endpoint) {
      action.href = gatewayUrl(root.getAttribute('data-gateway-path'), destination, productReturn);
    } else if (!authenticated) {
      action.href = loginUrl(root.getAttribute('data-gateway-path'), destination, root.getAttribute('data-locale'), productReturn);
    }

    function settle(message, busy) {
      status.textContent = root.getAttribute(message) || status.textContent;
      pending = busy;
      root.setAttribute('aria-busy', String(busy));
      action.setAttribute('aria-disabled', String(busy));
      if (spinner) spinner.hidden = !busy;
    }
    function clear() {
      if (timeout) win.clearTimeout(timeout);
      timeout = 0;
    }
    function fail(id) {
      if (id !== attempt) return;
      attempt += 1;
      clear();
      if (controller) controller.abort();
      controller = null;
      settle('data-error-message', false);
      action.textContent = root.getAttribute('data-retry-label') || action.textContent;
    }
    function invalidateIdentity() {
      if (!authenticated || identityInvalid) return;
      identityInvalid = true;
      attempt += 1;
      clear();
      if (controller) controller.abort();
      controller = null;
      action.href = loginUrl(root.getAttribute('data-gateway-path'), destination, root.getAttribute('data-locale'), productReturn);
      action.textContent = root.getAttribute('data-login-label') || action.textContent;
      settle('data-session-changed-message', false);
    }
    function proceed(event) {
      if (event) event.preventDefault();
      if (win.pgForumSession && win.pgForumSession.logoutVersion && win.pgForumSession.logoutVersion() !== initialLogoutVersion) invalidateIdentity();
      if (identityInvalid) {
        try { win.location.replace(action.href); } catch (_error) { /* The fresh Shopify sign-in link remains available. */ }
        return;
      }
      if (pending) return;
      if (!authenticated) {
        settle('data-login-message', true);
        try { win.location.replace(action.href); } catch (_error) { /* Keep the manual link usable. */ }
        settle('data-manual-message', false);
        return;
      }
      if (!endpoint || typeof win.fetch !== 'function' || typeof win.AbortController !== 'function' || !win.pgForumSession) {
        settle('data-error-message', false);
        return;
      }
      var id = ++attempt;
      controller = new win.AbortController();
      var signal = controller.signal;
      settle('data-connecting-message', true);
      timeout = win.setTimeout(function () { fail(id); }, 10000);
      Promise.resolve().then(function () {
        return win.pgForumSession.resetForum(signal);
      }).then(function () {
        if (id !== attempt || signal.aborted) throw new Error('forum_sso_cancelled');
        return win.fetch(endpoint.toString(), {
          credentials: 'include', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer', signal: signal
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('forum_sso_failed');
        return response.json();
      }).then(function (payload) {
        if (id !== attempt) return;
        if (!payload || payload.ok !== true) throw new Error('forum_sso_failed');
        clear();
        controller = null;
        win.location.replace(completedDestination);
      }).catch(function () { fail(id); });
    }

    action.addEventListener('click', function (event) {
      // A new tab also enters this gateway, so it cannot bypass the forum session reset.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      proceed(event);
    });
    reading.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      attempt += 1;
      clear();
      if (controller) controller.abort();
      controller = null;
      settle('data-manual-message', false);
    });
    var stopLogoutListener = win.pgForumSession ? win.pgForumSession.onLogout(invalidateIdentity) : null;
    win.addEventListener('pageshow', function (event) {
      // Restored HTML can contain an old customer's HMAC; re-enter Shopify before any new issue.
      if (event.persisted) invalidateIdentity();
    });
    win.addEventListener('pagehide', function () {
      attempt += 1;
      clear();
      if (controller) controller.abort();
      controller = null;
      settle('data-manual-message', false);
      if (stopLogoutListener) stopLogoutListener();
    }, { once: true });
    if (root.getAttribute('data-auto-continue') === 'true') proceed();
  }

  return { forumPath: forumPath, productPath: productPath, loginUrl: loginUrl, mount: mount };
});
